<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Simulation" />
            <SimulationPoste />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import SimulationPoste from '../Simulation/SimulationPoste'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicesPage',
    components: {
        NavBar,
        PageTitle,
        SimulationPoste,
        FooterComp,
    }
}
</script>